// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.h0vfO{width:260px;margin-block:12px 8px}.h0vfO.sM2Tq{width:100%}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"periodInput": `h0vfO`,
	"mobile": `sM2Tq`
};
export default ___CSS_LOADER_EXPORT___;
